import { render, staticRenderFns } from "./FileSelectorDialog.vue?vue&type=template&id=887aa506&scoped=true"
import script from "./FileSelectorDialog.vue?vue&type=script&lang=js"
export * from "./FileSelectorDialog.vue?vue&type=script&lang=js"
import style0 from "./FileSelectorDialog.vue?vue&type=style&index=0&id=887aa506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887aa506",
  null
  
)

export default component.exports